import { DataCardBadge, type DataBadgeVariant } from '@/components/blocks/DataCard';

interface AdmissionBadgeProps {
  isPrivate: boolean;
  admissionFee: number;
}

export function getAdmissionBadgeInfo(
  isPrivate: boolean,
  admissionFee: number,
): { text: string; color: DataBadgeVariant } {
  const text = isPrivate ? 'Invite Only' : admissionFee === 0 ? 'Free' : `$${admissionFee}`;
  const color = isPrivate ? 'brown' : admissionFee === 0 ? 'emerald' : 'blue';
  return { text, color };
}

export function AdmissionBadge({ isPrivate, admissionFee }: AdmissionBadgeProps) {
  const { text, color } = getAdmissionBadgeInfo(isPrivate, admissionFee);
  return <DataCardBadge color={color}>{text}</DataCardBadge>;
}
